module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-ingresso-personalizado.1315eb04.jpg";